import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { BlogProps } from 'models/blog-types';
import { useDictionary } from 'lib/utils';
import classNames from 'classnames/bind';
import styles from './Blog.module.scss';

const BlogAuthorLink: React.FC<BlogProps> = (props) => {
  const cx = classNames.bind(styles);
  const authorLabel = useDictionary('By');

  const { className, blogDetails } = props;
  const { sitecoreContext } = useSitecoreContext();

  return blogDetails?.blogAuthor ? (
    <div className={cx(className)}>
      {authorLabel}&nbsp;
      <Text field={blogDetails.blogAuthor.fields.authorName} encode={sitecoreContext.pageEditing} />
    </div>
  ) : (
    <></>
  );
};

export default BlogAuthorLink;
